import { callApi } from 'utils/api/callApi'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import * as Types from 'apps/fleet-planner/types'

/**
 * Returns list of shares for that shipment
 */
export const fetchShipmentShares = (
  shipmentId: string
): Promise<Types.IGetShipmentSharesResponse> => {
  const requestData = {
    method: 'GET',
    endpoint: FP_ENDPOINTS.shipments,
    id: shipmentId,
    group: 'shares',
  }
  return callApi(requestData)
}

/**
 * Create new share for shipment
 */
export const createShare = (
  shipmentId: string,
  driverId: string
): Promise<Types.ICreateShareResponse> => {
  const requestData = {
    method: 'POST',
    endpoint: FP_ENDPOINTS.shipments,
    id: shipmentId,
    group: 'shares',
    body: {
      sharedWithDriverId: driverId,
    },
  }

  return callApi(requestData)
}

/**
 * Delete share by id
 */
export const deleteShare = (shipmentId: string, shareId: string): Promise<void> => {
  const requestData = {
    method: 'DELETE',
    endpoint: FP_ENDPOINTS.shipments,
    id: shipmentId,
    group: `shares/${shareId}`,
  }

  return callApi(requestData)
}

/**
 * Get shipment details with id and token
 */
export const fetchShipment = (
  shipmentId?: string,
  token?: string
): Promise<Types.IGetShipmentResponse> => {
  const requestData = {
    method: 'GET',
    endpoint: FP_ENDPOINTS.shared_shipments,
    id: shipmentId,
    params: { share_token: token },
  }

  return callApi(requestData)
}

/**
 * Update shipment status and in/out times
 */
export const updateStatus = (
  shipmentId: string,
  shipment: Types.IShipmentStatusUpdate,
  token: string
): Promise<Types.IGetShipmentResponse> => {
  const requestData = {
    method: 'PUT',
    group: 'status',
    endpoint: FP_ENDPOINTS.shared_shipments,
    id: shipmentId,
    params: { share_token: token },
    body: { shipment },
  }

  return callApi(requestData)
}

/**
 * Update shipment status and in/out times
 */
export const updateCheckInOut = (
  shipmentId: string,
  stopId: string,
  stop: Types.IShipmentInOutUpdate,
  token: string
): Promise<Types.IGetShipmentResponse> => {
  const requestData = {
    method: 'PATCH',
    group: `stops/${stopId}/check_in_out`,
    endpoint: FP_ENDPOINTS.shared_shipments,
    id: shipmentId,
    params: { share_token: token },
    body: { stop },
  }

  return callApi(requestData)
}

/**
 * Upload POD file
 */
export const uploadPod = (
  shipmentId: string,
  shipment: Types.IShipmentPodUpdate,
  token: string
): Promise<Types.IGetShipmentResponse> => {
  const requestData = {
    method: 'PUT',
    group: 'attachments',
    endpoint: FP_ENDPOINTS.shared_shipments,
    id: shipmentId,
    params: { share_token: token },
    body: { shipment },
  }

  return callApi(requestData)
}

/**
 * Submit One-Time Location
 */
export const submitLocation = (
  shipmentId: string,
  latitude: number,
  longitude: number,
  isManual: boolean,
  token: string,
  externalStopId?: string
): Promise<Types.IGetShipmentResponse> => {
  const requestData = {
    method: 'POST',
    group: 'one_time_location',
    endpoint: FP_ENDPOINTS.shared_shipments,
    id: shipmentId,
    params: { share_token: token },
    body: { latitude, longitude, isManual, externalStopId },
  }

  return callApi(requestData)
}
